module.exports = __webpack_public_path__ + "assets/Lato-Bold.ae88fc0d7a961832f809527d30bd3983a6866d42f66a56ade23f543681594db6.woff2";